import React from 'react';

const BuiltForRecruiting: React.FC = () => {
    return (
        <section className="relative px-4 py-8 sm:py-10 lg:py-12">
            <div className="container mx-auto max-w-[1640px]">
                {/* Section Title */}
                <h2
                    className="text-left mb-6 sm:mb-8 lg:mb-10"
                    style={{
                        fontFamily: 'Manrope',
                        fontStyle: 'normal',
                        fontWeight: 700,
                        fontSize: 'clamp(32px, 6vw, 72px)',
                        lineHeight: 'clamp(40px, 7vw, 90px)',
                        letterSpacing: '-0.05em',
                        color: '#FFFFFF',
                        maxWidth: '100%',
                    }}
                >
                    Built for modern recruiting
                </h2>

                {/* Cards Container */}
                <div className="flex flex-col lg:flex-row gap-8 lg:gap-[33px] max-w-full mx-auto justify-center">
                    {/* Card 1: For Candidates */}
                    <div className="w-full lg:flex-1 lg:max-w-[841px] min-h-[400px] lg:min-h-[678px] box-border relative rounded-[24px] lg:rounded-[40px] p-6 lg:p-0"
                        style={{
                            background: 'radial-gradient(146.13% 118.42% at 50% -15.5%, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 99.59%), linear-gradient(180deg, rgba(46, 51, 90, 0) 0%, rgba(28, 27, 51, 0.1) 100%)',
                            border: '1px solid rgba(255, 255, 255, 0.15)',
                            boxShadow: 'inset 0px 0px 100px rgba(204, 215, 255, 0.15)',
                            filter: 'drop-shadow(0px 5px 10px rgba(0, 0, 0, 0.05)) drop-shadow(0px 15px 30px rgba(0, 0, 0, 0.05)) drop-shadow(0px 30px 60px rgba(0, 0, 0, 0.1))',
                            backdropFilter: 'blur(10px)',
                        }}
                    >
                        {/* Title */}
                        <h3 className="static lg:absolute lg:left-8 lg:top-8 mb-4 lg:mb-0"
                            style={{
                                fontFamily: 'Manrope',
                                fontStyle: 'normal',
                                fontWeight: 700,
                                fontSize: 'clamp(28px, 5vw, 40px)',
                                lineHeight: 'clamp(38px, 6vw, 55px)',
                                textAlign: 'left',
                                letterSpacing: '-0.05em',
                                color: '#FFFFFF',
                                margin: 0,
                            }}
                        >
                            For Candidates
                        </h3>

                        {/* Description */}
                        <ul className="static lg:absolute lg:left-8 lg:top-[111px] mb-6 lg:mb-0 max-w-full lg:max-w-[500px]"
                            style={{
                                fontFamily: 'Manrope',
                                fontStyle: 'normal',
                                fontWeight: 300,
                                fontSize: 'clamp(16px, 3vw, 24px)',
                                lineHeight: 'clamp(22px, 4vw, 33px)',
                                letterSpacing: '-0.05em',
                                color: '#FFFFFF',
                                margin: 0,
                                paddingLeft: '20px',
                            }}
                        >
                            <li>Only share your profile when you're ready</li>
                            <li>Get matched with roles tailored to your career.</li>
                            <li>Proactively find your dream role.</li>
                        </ul>

                        {/* Product Placeholder */}
                        <div className="static lg:absolute w-full max-w-[280px] lg:max-w-[585px] mx-auto lg:mx-0 lg:left-[calc(50%-585px/2+99.25px)] lg:top-[267px]"
                            style={{
                                boxSizing: 'border-box',
                                aspectRatio: '585 / 376',
                                background: 'transparent',
                                border: '0.75px solid rgba(255, 255, 255, 0.5)',
                                boxShadow: '0px 3.75px 7.5px rgba(0, 0, 0, 0.05), 0px 11.25px 22.5px rgba(0, 0, 0, 0.05), 0px 22.5px 45px rgba(0, 0, 0, 0.1), inset 0px 37.5px 75px rgba(255, 255, 255, 0.15)',
                                backdropFilter: 'blur(7.5px)',
                                borderRadius: '22.5px',
                            }}
                        />
                    </div>

                    {/* Card 2: For Employers */}
                    <div className="w-full lg:flex-1 lg:max-w-[842px] min-h-[400px] lg:min-h-[678px] box-border relative rounded-[24px] lg:rounded-[40px] p-6 lg:p-0"
                        style={{
                            background: 'radial-gradient(146.13% 118.42% at 50% -15.5%, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 99.59%), linear-gradient(180deg, rgba(46, 51, 90, 0) 0%, rgba(28, 27, 51, 0.1) 100%)',
                            border: '1px solid rgba(255, 255, 255, 0.15)',
                            boxShadow: 'inset 0px 0px 100px rgba(204, 215, 255, 0.15)',
                            filter: 'drop-shadow(0px 5px 10px rgba(0, 0, 0, 0.05)) drop-shadow(0px 15px 30px rgba(0, 0, 0, 0.05)) drop-shadow(0px 30px 60px rgba(0, 0, 0, 0.1))',
                            backdropFilter: 'blur(10px)',
                        }}
                    >
                        {/* Product Placeholder */}
                        <div className="static lg:absolute w-full max-w-[280px] lg:max-w-[585px] mx-auto lg:mx-0 mb-6 lg:mb-0 lg:left-[calc(50%-585px/2-96.25px)] lg:top-[43px]"
                            style={{
                                boxSizing: 'border-box',
                                aspectRatio: '585 / 376',
                                background: 'transparent',
                                border: '0.75px solid rgba(255, 255, 255, 0.5)',
                                boxShadow: '0px 3.75px 7.5px rgba(0, 0, 0, 0.05), 0px 11.25px 22.5px rgba(0, 0, 0, 0.05), 0px 22.5px 45px rgba(0, 0, 0, 0.1), inset 0px 37.5px 75px rgba(255, 255, 255, 0.15)',
                                backdropFilter: 'blur(7.5px)',
                                borderRadius: '22.5px',
                            }}
                        />

                        {/* Title */}
                        <h3 className="static lg:absolute lg:left-[282px] lg:top-[443px] mb-4 lg:mb-0"
                            style={{
                                fontFamily: 'Manrope',
                                fontStyle: 'normal',
                                fontWeight: 700,
                                fontSize: 'clamp(28px, 5vw, 40px)',
                                lineHeight: 'clamp(38px, 6vw, 55px)',
                                textAlign: 'left',
                                letterSpacing: '-0.05em',
                                color: '#FFFFFF',
                                margin: 0,
                            }}
                        >
                            For Employers
                        </h3>

                        {/* Description */}
                        <ul className="static lg:absolute lg:left-[282px] lg:top-[522px] max-w-full lg:max-w-[523px]"
                            style={{
                                fontFamily: 'Manrope',
                                fontStyle: 'normal',
                                fontWeight: 300,
                                fontSize: 'clamp(16px, 3vw, 24px)',
                                lineHeight: 'clamp(22px, 4vw, 33px)',
                                letterSpacing: '-0.05em',
                                color: '#FFFFFF',
                                margin: 0,
                                paddingLeft: '20px',
                            }}
                        >
                            <li>Cut hiring costs with higher success rates.</li>
                            <li>Engage only with interested, qualified candidates.</li>
                            <li>Scale recruiting from one role to hundreds.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BuiltForRecruiting;
